import { io } from "socket.io-client";

const socket = io("https://api.joss-serveur.duckdns.org", {
  autoConnect: false,
});

export default socket;